/**
 * Generates a material label with proper HTML formatting for subscripts
 * Based on the legacy Material.updateComponents logic
 */
export function generateMaterialLabel(name: string, form?: string): string {
  const parts = name.split(/(?=[A-Z0-9x\-(),])/);
  let label = '';
  const components: string[] = [];

  for (let i = 0; i < parts.length; i++) {
    if (/[(),]/.test(parts[i])) {
      // Don't subscript parentheses
      label += parts[i];
    } else if (parts[i] === '-' && i > 0 && !/[.0-9]/.test(parts[i - 1])) {
      // A dash is in index only when preceded by a number
      label += parts[i];
    } else if (parts[i].toLowerCase() === parts[i]) {
      // Anything else that does not contain a capital letter is an index: numbers, x
      label += `<sub>${parts[i]}</sub>`;
    } else {
      components.push(parts[i]);
      label += parts[i];
    }
  }

  // Add form if provided
  if (form) {
    label += ` (${form})`;
  }

  return label;
}

/**
 * Extracts components from a material name
 */
export function extractMaterialComponents(name: string): string[] {
  const parts = name.split(/(?=[A-Z0-9x\-(),])/);
  const components: string[] = [];

  for (let i = 0; i < parts.length; i++) {
    if (!/[(),]/.test(parts[i]) && parts[i] !== '-' && parts[i].toLowerCase() !== parts[i]) {
      components.push(parts[i]);
    }
  }

  return components;
}
